import "../assets/styles/Timeline.scss";

function about() {
  return (
    <div id="about">
      <div className="items-container">
        <h1>About</h1>
        <h4>
          I began my development journey as a coder in 2014, creating websites
          from scratch using available documentation. As the year progressed, my
          curiosity in the field of development grew. I started using no-code
          software to develop mobile applications and tested them on my device.
          I was also enthusiastic about cybersecurity, actively participating in
          online discussions and engaging in pentesting.
          <br />
          <br /> My engineering background in electronics and communications
          provided me with valuable exposure to the field of IoT. This
          experience helped me discover how seamlessly software and hardware can
          be integrated to simplify life through automation. I also explored
          microprocessors, writing and testing code directly on them to
          understand how things work at the core level.
          <br />
          <br /> Pursuing my passion for engineering and development, I
          transitioned to full-stack development, immersing myself in various
          programming languages and frameworks such as JavaScript, and their
          associated libraries and tools. My fascination with automation and
          efficiency led me to adopt containerization and orchestration
          technologies like Docker and Kubernetes, thereby augmenting my
          proficiency in DevOps practices. With a firm grounding in
          cybersecurity principles, I am committed to crafting code that is not
          only robust and efficient but also resilient against online
          vulnerabilities. I remain dedicated to the continuous discovery and
          resolution of bugs, ensuring the integrity and security of the systems
          I develop, while actively upgrading my skills in cybersecurity to stay
          abreast of the latest threats and defense mechanisms.
        </h4>
      </div>
    </div>
  );
}

export default about;
